import  { useEffect } from "react";
import { clearLocalStorage } from "../../core/localStorageService";
import { useNavigate } from "react-router";

/**
 * Renders Component.
 * @return {Logout} renders Component.
 */
export default function Logout() {
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.clear();
    clearLocalStorage();
    navigate("/");
  }, [navigate]);

  
}
